import { render, staticRenderFns } from "./medicalResource.vue?vue&type=template&id=5718dc25&scoped=true"
import script from "./medicalResource.vue?vue&type=script&lang=js"
export * from "./medicalResource.vue?vue&type=script&lang=js"
import style0 from "./medicalResource.vue?vue&type=style&index=0&id=5718dc25&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5718dc25",
  null
  
)

export default component.exports